<script>
    import { _ } from '../services/i18n'
    export let orderId = 0;
    export let sceneId = 0;
    export let optionalText = "";
    export let styleVariant = "";
    export let align = "left";

    import config from "../config";

    
</script>

{#if config.viewer?.enabled}
    <div class={`btn-container align-${align}`}>
        <a class={`VisorButton variant-${styleVariant}`} href={`/viewer.html#/viewer/order/${orderId}/${sceneId}`} target="_blank" rel="noreferrer">
            {optionalText}  
            {#if styleVariant === "small" }
                <img src="/icons/video-3d-variant.svg" class="viewer-logo" alt="3DViewer">
            {:else}
                <img src="/icons/video-3d-variant.svg" class="viewer-logo" alt="3DViewer">
            {/if}
        </a>
    </div>
{/if}

<style>
    .btn-container {
        width: fit-content;
        position: relative;
        float: left;
    }

    .btn-container.align-left {
        float: left;
    }

    .btn-container.align-right {
        float: right;
    }
    
    .VisorButton.variant-small {
        float: left;
        margin: 5px 0px 5px 4px;
        border-radius: 5px;
        background-color: var(--theme-color-1);
        color: #fff;
        border: 0 none;
        padding: 2px 7px;
        text-align: center;
        width: fit-content;
        position: relative;
        transition: all 0.25s ease-in-out;
        font-size: 8px;
    }

    .VisorButton.variant-medium {
        float: right;
        margin: 5px;
        border-radius: 50%;
        background-color: var(--theme-color-1);
        color: #fff;
        border: 0 none;
        padding: 2px 7px;
        text-align: center;
        width: 46px;
        height: 46px;
        position: relative;
        transition: all 0.25s ease-in-out;
    }

    .VisorButton.variant-small img.viewer-logo {
        width: 18px !important;
        height: 18px !important;
        border: none;
    }

    .VisorButton.variant-medium img.viewer-logo {
        width: 36px !important;
        height: 36px !important;
        border: none;
        margin-top: 3px;
    }

    .VisorButton.variant-small:hover {
        background-color: var(--theme-color-4);
        color: #fff;
    }

    .VisorButton.variant-medium:hover {
        background-color: var(--theme-color-4);
        -webkit-animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        color: #fff;
    }

    .VisorButton.variant-small:hover:before {
        background-color: var(--theme-color-4);
    }

    .VisorButton.variant-medium:hover:before {
        background-color: var(--theme-color-4);
        -webkit-animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
    }
        
    .VisorButton.variant-small:hover:after {
        background-color: var(--theme-color-4);
    }

    .VisorButton.variant-medium:hover:after {
        background-color: var(--theme-color-4);
        -webkit-animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;

    }

    .VisorButton:before,
    .VisorButton:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--theme-color-1);
        width: 100%;
        height: 100%;
        border-radius: 5px;
        opacity: 0;
        transition: all 0.25s ease-in-out;
    }
    a:hover {
        text-decoration: none;
    }
    @-webkit-keyframes VisorButton-beat {
        0% {
            opacity: 0.8;
            transform: scale(1);
        }
        70% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes VisorButton-beat {
        0% {
            opacity: 0.8;
            transform: scale(1);
        }
        70% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 0;
        }
    }
</style>

<svelte:head>
    <script src="https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js" integrity="sha512-BNaRQnYJYiPSqHHDb58B0yaPfCu+Wgds8Gp/gU33kqBtgNS4tSPHuGibyoeqMV/TJlSKda6FXzoEyYGjTe+vXA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
</svelte:head>